export default __webpack_public_path__ + "c2441c3e6c6b6404372b71354b858003.jpg";